export const en: Record<string, string> = {
    'dashboard.nav.overview': 'Overview',
    'dashboard.nav.users': 'Users',
    'dashboard.nav.prompts': 'Prompts',
    'dashboard.nav.testConfigs': 'Test configurations',
    'dashboard.nav.sensecap': 'SenseCAP',
    'dashboard.nav.deviceSensors': 'Device sensors',
    'dashboard.nav.postureInstructions': 'Posture instructions',
    'dashboard.nav.mediaFiles': 'Media library',
    'dashboard.nav.testMetrics': 'Test metrics',
    'dashboard.nav.disclaimers': 'Disclaimers',
    'dashboard.nav.legalDocuments': 'Legal documents',
    'dashboard.nav.testCategories': 'Test categories',
    'dashboard.nav.entitlements': 'Entitlements',
    'dashboard.nav.questionnaires': 'Questionnaires',
    'dashboard.nav.testScripts': 'Python scripts',
    'dashboard.collapseSidebar': 'Collapse menu',
    'dashboard.expandSidebar': 'Expand menu',
    'dashboard.logout': 'Log out',

    'login.title': 'Sign in',
    'login.password': 'Password',
    'login.submit': 'Sign in',

    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.add': 'Add',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.copy': 'Copy',
    'common.done': 'Done',
    'common.loading': 'Loading...',
    'common.noData': 'No data',
    'common.error': 'Error',

    'keyValue.key': 'Key',
    'keyValue.value': 'Value',
    'keyValue.actions': 'Actions',
    'keyValue.editTitle': 'Edit: {key}',
    'keyValue.addTitle': 'Add',
    'keyValue.newKey': 'New key',
    'keyValue.applyAll': 'Apply to all users',
    'keyValue.userProps': 'User properties',
    'keyValue.userFiles': 'User files',
    'keyValue.userPrompts': 'User prompts',
    'keyValue.description': 'Description',
    'keyValue.image': 'Image',
    'keyValue.replaceImage': 'Replace image',
    'keyValue.chooseImage': 'Choose image',
    'keyValue.preview': 'Preview',
    'keyValue.removeImage': 'Remove image',
    'keyValue.generatedRecs': 'Generated recommendations:',
    'keyValue.confirmDelete': 'Are you sure you want to delete this entry?',
    'keyValue.confirmApplyAll':
        'Apply this user’s properties to ALL users?\nAll existing properties of other users will be removed!',
    'keyValue.applySuccess': 'Properties applied to all users successfully.',
    'keyValue.errorPrefix': 'Error: {message}',
    'keyValue.keyEmpty': 'Key cannot be empty',
    'keyValue.addFailed': 'Could not add property',
    'keyValue.duplicateKey': 'Property with key "{key}" already exists',

    'reports.deleteRow': 'Delete',
    'reports.deleteEcgConfirm': 'Are you sure you want to delete this ECG?',
    'reports.testConfig': 'Test config',

    'users.manageProps': 'Manage user properties',
    'users.generateRec': 'Generate recommendation',
    'users.generating': 'Generating...',
    'users.genFailed': 'Could not generate recommendations',
    'users.manager': 'Manager',
    'users.assignManager': 'Assign manager',
    'users.clearManager': 'No manager',
    'users.managerSaved': 'Manager updated',
    'users.managerSaveFailed': 'Could not update manager',

    'reportDetail.deleteReportConfirm': 'Delete this report?',
    'reportDetail.deleteFailed': 'Could not delete report',
    'reportDetail.xlsFailed': 'Could not download XLS',
    'reportDetail.errorStatus': 'Error {status}',
    'reportDetail.pdfFailed': 'Could not download PDF',
    'reportDetail.shortPdfFailed': 'Could not download short PDF',
    'reportDetail.selectPrompt': 'Select a prompt',
    'reportDetail.genError': 'Generation error',
    'reportDetail.genFailed': 'Could not generate recommendations',
    'reportDetail.notFound': 'Report not found.',
    'reportDetail.backToUser': 'Back to user',
    'reportDetail.reportN': 'Report #{id}',
    'reportDetail.date': 'Date:',
    'reportDetail.comment': 'Comment:',
    'reportDetail.user': 'User:',
    'reportDetail.properties': 'Properties',
    'reportDetail.propertiesTime': 'Time',
    'reportDetail.propertiesName': 'Name',
    'reportDetail.propertiesValue': 'Value',
    'reportDetail.testConfig': 'Test config:',
    'reportDetail.testConfigCategory': 'Category:',
    'reportDetail.ecgFilter': 'Build ECG with filter',
    'reportDetail.shortPdf': 'Short PDF',
    'reportDetail.aiGen': 'AI generation',
    'reportDetail.optionalQuestion': 'Clarifying question (optional)',
    'reportDetail.clarifyingQuestionLabel': 'Clarifying question',
    'reportDetail.generating': 'Generating…',
    'reportDetail.generate': 'Generate',
    'reportDetail.result': 'Result',
    'reportDetail.inputSent': 'Input (sent)',
    'reportDetail.answer': 'Response',
    'reportDetail.history': 'Generation history',
    'reportDetail.noHistory': 'No entries',
    'reportDetail.inputHistory': 'Input:',
    'reportDetail.answerHistory': 'Response:',

    'prompts.status.draft': 'Draft',
    'prompts.status.active': 'Published',
    'prompts.status.archived': 'Archived',
    'prompts.deleteConfirm': 'Delete this prompt?',
    'prompts.deleteFailed': 'Could not delete',
    'prompts.title': 'All prompts',
    'prompts.allUsers': 'All users',
    'prompts.allReportTypes': 'All report types',
    'prompts.add': 'Add prompt',
    'prompts.colUser': 'User',
    'prompts.colReportType': 'Report type',
    'prompts.colName': 'Name',
    'prompts.colStatus': 'Status',
    'prompts.colUpdated': 'Last updated',
    'prompts.colActions': 'Actions',
    'prompts.empty': 'No prompts',
    'prompts.editHint': 'Edit',
    'prompts.historyHint': 'Change history',
    'prompts.deleteHint': 'Delete',
    'prompts.enterName': 'Enter a name',
    'prompts.enterText': 'Enter prompt text',
    'prompts.saveFailed': 'Could not save',
    'prompts.newTitle': 'New prompt',
    'prompts.forAllUsers': 'For all users',
    'prompts.globalAlreadyExists':
        'A prompt for all users already exists for this report type. Edit the existing one.',
    'prompts.user': 'User',
    'prompts.name': 'Name',
    'prompts.reportType': 'Report type',
    'prompts.publishNow': 'Publish now',
    'prompts.saveAsDraft': 'Save as draft',
    'prompts.promptText': 'Prompt text',
    'prompts.note': 'Note',
    'prompts.saveDraftBtn': 'Save draft',
    'prompts.publish': 'Publish',
    'prompts.editTitlePrefix': 'Edit:',
    'prompts.reportTypeStatic': 'Report type:',
    'prompts.publishRadio': 'Publish',
    'prompts.draftRadio': 'Draft',
    'prompts.versionTitle': 'Prompt version history',
    'prompts.savedRevisions': 'Saved revisions',
    'prompts.when': 'When',
    'prompts.version': 'Version',
    'prompts.content': 'Content',
    'prompts.activeCol': 'Active',
    'prompts.actionsCol': 'Actions',
    'prompts.makeActive': 'Set active',
    'prompts.testCopies': 'Test branches',
    'prompts.noCopies': 'No copies',
    'prompts.createCopy': '+ Create test copy',
    'prompts.creating': 'Creating...',
    'prompts.branchFailed': 'Could not create copy',
    'prompts.allStatuses': 'All statuses',
    'prompts.migrateGlobalDuplicates': 'Migrate copied prompts',
    'prompts.migrateGlobalDuplicatesConfirm':
        'Create global templates from old copied prompts? Personal copies will not be deleted.',
    'prompts.migrateGlobalDuplicatesSuccess':
        'Migration complete. Created: {globalCreated}, groups found: {groupsFound}, skipped: {skipped}.',
    'prompts.migrateGlobalDuplicatesFailed': 'Could not migrate prompts',
    'userPrompts.selectReportBelow': 'Select a report in the table below',
    'userPrompts.getAiRecommendations': 'Get AI recommendations',
    'userPrompts.selectReportHint':
        'Select a report in the table below, then click the AI recommendations icon for the prompt you need.',
    'userPrompts.howSave': 'How to save:',
    'userPrompts.noteForSelf': 'Note (private)',

    'documents.loadFailed': 'Could not load documents',
    'documents.pdfOnly': 'Only PDF files are allowed',
    'documents.sizeLimit': 'File size must not exceed 10MB',
    'documents.pickFile': 'Choose a file to upload',
    'documents.uploaded': 'Document uploaded successfully',
    'documents.uploadFailed': 'Could not upload document',
    'documents.deleteConfirm': 'Delete this document?',
    'documents.deleted': 'Document deleted',
    'documents.deleteFailed': 'Could not delete document',
    'documents.downloading': 'Download started',
    'documents.downloadFailed': 'Could not download document',
    'documents.previewFailed': 'Could not open document',
    'documents.name': 'Name',
    'documents.size': 'Size',
    'documents.uploadedAt': 'Uploaded',
    'documents.actions': 'Actions',
    'documents.download': 'Download',
    'documents.empty': 'No uploaded documents',
    'documents.uploadTitle': 'Upload document',
    'documents.chooseFile': 'Choose file',
    'documents.fileLabel': 'File:',
    'documents.sizeLabel': 'Size:',
    'documents.pdfHint': 'PDF only, up to 10MB',
    'documents.uploading': 'Uploading...',
    'documents.upload': 'Upload',
    'documents.previewTitle': 'Preview:',
    'documents.uploadButton': 'Upload document',
    'documents.stats': 'Total: {count} • Total size: {size}',

    'testConfigs.error': 'Error',
    'testConfigs.uncategorized': 'Uncategorized',
    'testConfigs.deleteConfirm': 'Delete configuration "{name}"?',
    'testConfigs.scriptLoadFailed': 'Could not upload script',
    'testConfigs.deleteScriptConfirm': 'Delete script?',
    'testConfigs.title': 'Test configurations',
    'testConfigs.new': 'New configuration',
    'testConfigs.newCategory': 'New category',
    'testConfigs.refresh': 'Refresh',
    'testConfigs.noConfigs': 'No configurations',
    'testConfigs.createFirst': 'Create first',
    'testConfigs.selectConfig': 'Select a configuration',
    'testConfigs.edit': 'Edit',
    'testConfigs.copy': 'Copy',
    'testConfigs.newCategoryDialog': 'New category',
    'testConfigs.categoryName': 'Category name',
    'testConfigs.create': 'Create',
    'testConfigs.script': 'Script',
    'testConfigs.pdfScript': 'PDF generation script',
    'testConfigs.indicatorsScript': 'Indicators script',
    'testConfigs.noScript': 'Not selected',
    'testConfigs.scriptPresent': 'Present',
    'testConfigs.replace': 'Replace',
    'testConfigs.remove': 'Remove',
    'testConfigs.uploadPy': 'Upload .py',
    'testConfigs.enabled': 'Enabled',
    'testConfigs.copySuffix': ' (copy)',
    'testConfigs.enterName': 'Enter a name',
    'testConfigs.pickOutputMetric': 'Select at least one metric in Output metrics',
    'testConfigs.saveFailed': 'Could not save',
    'testConfigs.dialogEdit': 'Edit configuration',
    'testConfigs.dialogCopy': 'Copy configuration',
    'testConfigs.dialogNew': 'New configuration',
    'testConfigs.fieldName': 'Name',
    'testConfigs.fieldType': 'Type',
    'testConfigs.fieldDescription': 'Description',
    'testConfigs.fieldGoal': 'Goal',
    'testConfigs.fieldSensors': 'Sensors',
    'testConfigs.fieldPosture': 'Posture',
    'testConfigs.fieldOutput': 'Output data',
    'testConfigs.fieldWhy': 'Why it matters',
    'testConfigs.fieldHow': 'How it works',
    'testConfigs.durationSec': 'Duration (sec)',
    'testConfigs.stages': 'Stages',
    'testConfigs.outputMetrics': 'Output metrics',
    'testConfigs.resultMetrics': 'Result metrics',
    'testConfigs.fieldCategory': 'Category',
    'testConfigs.fieldIndex': 'Index',
    'testConfigs.iconColor': 'Icon color',
    'testConfigs.icon': 'Icon',
    'testConfigs.chipActive': 'Active',
    'testConfigs.chipDisabled': 'Disabled',
    'testConfigs.durationChip': 'Duration: {n} sec',
    'testConfigs.stagesChip': 'Stages: {n}',
    'testConfigs.categoryId': 'Category',
    'testConfigs.sensorIds': 'Device sensors',
    'testConfigs.postureInstructionIds': 'Posture instructions',
    'testConfigs.fieldStatus': 'Status',
    'testConfigs.status.active': 'Active',
    'testConfigs.status.inactive': 'Inactive',
    'testConfigs.status.hidden': 'Hidden',
    'testConfigs.status.dep': 'Deprecated',
    'testConfigs.entitlementIds': 'Entitlements',
    'testConfigs.disclaimerIds': 'Disclaimers',
    'testConfigs.entitlementIdsHint': 'Empty = no restrictions',
    'testConfigs.migrateEntitlements': 'Migrate entitlements',
    'testConfigs.migrateEntitlementsHint':
        'Some configurations or categories still use legacy entitlement strings. Run migration to link them to the catalog.',
    'testConfigs.migrateEntitlementsSuccess':
        'Entitlement migration done: {created} created, {linkedConfigs} configs linked, {linkedCategories} categories linked',
    'testConfigs.metadata': 'Metadata (JSON)',
    'testConfigs.pickCategory': 'Select a category',
    'testConfigs.invalidMetadata': 'Invalid metadata JSON',
    'testConfigs.migrateCategories': 'Migrate categories',
    'testConfigs.migrateCategoriesHint': 'Some configurations use legacy category names without a catalog link. Run migration to attach them to TestCategory.',
    'testConfigs.migrateSuccess': 'Migration done: {updated} updated, {created} categories created',
    'testConfigs.fieldMediaFile': 'Icon (media library)',
    'testConfigs.fieldInstructionMedia': 'Instruction media (audio/video)',
    'testConfigs.migrateIcons': 'Migrate icons',
    'testConfigs.migrateIconsHint':
        'Some configurations or categories still use legacy static icon keys. Run migration to import icons into the media library and link records.',
    'testConfigs.migrateIconsSuccess':
        'Icon migration done: {imported} imported, {linkedConfigs} configs linked, {linkedCategories} categories linked',
    'testConfigs.migrateIconsUnmatched': '{count} records could not be matched to a file',
    'testConfigs.migrateMediaFiles': 'Migrate media files',
    'testConfigs.migrateMediaFilesHint':
        'Some records still reference the legacy SVG library. Run migration to copy files into the media library and link records.',
    'testConfigs.migrateMediaFilesSuccess':
        'Media migration done: {migrated} files migrated, {linkedPostures} postures linked, {linkedConfigs} configs linked, {linkedCategories} categories linked',
    'testConfigs.categoryUnlinked': 'Category "{name}" is not linked to the catalog',
    'testConfigs.manageCategories': 'Manage categories',

    'testCategories.title': 'Test categories',
    'testCategories.new': 'New category',
    'testCategories.refresh': 'Refresh',
    'testCategories.empty': 'No categories',
    'testCategories.deleteConfirm': 'Delete category "{type}"?',
    'testCategories.deleteFailed': 'Failed to delete category',
    'testCategories.saveFailed': 'Failed to save category',
    'testCategories.enterType': 'Enter category type',
    'testCategories.enterName': 'Enter name',
    'testCategories.enterDescription': 'Enter description',
    'testCategories.invalidHex': 'Invalid hex color (#RRGGBB)',
    'testCategories.dialogNew': 'New test category',
    'testCategories.dialogEdit': 'Edit test category',
    'testCategories.colType': 'Type',
    'testCategories.colName': 'Name',
    'testCategories.colItemsName': 'Items name',
    'testCategories.colSortOrder': 'Sort order',
    'testCategories.colStatus': 'Status',
    'testCategories.colActions': 'Actions',
    'testCategories.fieldType': 'Type',
    'testCategories.fieldName': 'Name',
    'testCategories.fieldDescription': 'Description',
    'testCategories.fieldItemsName': 'Items name',
    'testCategories.fieldIcon': 'Icon',
    'testCategories.fieldMediaFile': 'Icon (media library)',
    'testCategories.colIcon': 'Icon',
    'testCategories.fieldIconColor': 'Icon color',
    'testCategories.fieldSortOrder': 'Sort order',
    'testCategories.fieldStatus': 'Status',
    'testCategories.fieldEntitlements': 'Entitlements',
    'testCategories.entitlementIds': 'Entitlements',
    'testCategories.entitlementIdsHint': 'Empty = no restrictions',
    'testCategories.status.active': 'Active',
    'testCategories.status.inactive': 'Inactive',
    'testCategories.status.archived': 'Archived',

    'deviceSensors.title': 'Device sensors',
    'deviceSensors.new': 'New sensor',
    'deviceSensors.refresh': 'Refresh',
    'deviceSensors.empty': 'No sensors',
    'deviceSensors.deleteConfirm': 'Delete sensor "{type}"?',
    'deviceSensors.deleteFailed': 'Failed to delete sensor',
    'deviceSensors.saveFailed': 'Failed to save sensor',
    'deviceSensors.enterType': 'Enter sensor type',
    'deviceSensors.enterDescription': 'Enter description',
    'deviceSensors.dialogNew': 'New device sensor',
    'deviceSensors.dialogEdit': 'Edit device sensor',
    'deviceSensors.colType': 'Type',
    'deviceSensors.colDescription': 'Description',
    'deviceSensors.colStatus': 'Status',
    'deviceSensors.colActions': 'Actions',
    'deviceSensors.fieldType': 'Type',
    'deviceSensors.fieldDescription': 'Description',
    'deviceSensors.fieldStatus': 'Status',
    'deviceSensors.status.active': 'Active',
    'deviceSensors.status.inactive': 'Inactive',
    'entitlements.title': 'Entitlements',
    'entitlements.new': 'New entitlement',
    'entitlements.refresh': 'Refresh',
    'entitlements.empty': 'No entitlements',
    'entitlements.deleteConfirm': 'Delete entitlement "{type}"?',
    'entitlements.deleteFailed': 'Failed to delete entitlement',
    'entitlements.saveFailed': 'Failed to save entitlement',
    'entitlements.enterType': 'Enter entitlement type',
    'entitlements.dialogNew': 'New entitlement',
    'entitlements.dialogEdit': 'Edit entitlement',
    'entitlements.colType': 'Type',
    'entitlements.colDescription': 'Description',
    'entitlements.colStatus': 'Status',
    'entitlements.colActions': 'Actions',
    'entitlements.fieldType': 'Type',
    'entitlements.fieldDescription': 'Description',
    'entitlements.status.active': 'Active',
    'entitlements.status.inactive': 'Inactive',
    'entitlements.status.archived': 'Archived',

    'questionnaires.title': 'Questionnaires',
    'questionnaires.new': 'New questionnaire',
    'questionnaires.refresh': 'Refresh',
    'questionnaires.empty': 'No questionnaires',
    'questionnaires.emptyQuestions': 'No questions',
    'questionnaires.emptyOptions': 'No options',
    'questionnaires.questionnaires': 'Questionnaires',
    'questionnaires.questions': 'Questions',
    'questionnaires.options': 'Options',
    'questionnaires.newQuestion': 'New question',
    'questionnaires.newOption': 'New option',
    'questionnaires.selectQuestionnaire': 'Select a questionnaire',
    'questionnaires.selectQuestion': 'Select a question',
    'questionnaires.deactivateConfirm': 'Deactivate “{title}”?',
    'questionnaires.saveFailed': 'Failed to save',
    'questionnaires.requiredFields': 'Code and title are required',
    'questionnaires.dialogNew': 'New questionnaire',
    'questionnaires.dialogEdit': 'Edit questionnaire',
    'questionnaires.dialogNewQuestion': 'New question',
    'questionnaires.dialogEditQuestion': 'Edit question',
    'questionnaires.dialogNewOption': 'New option',
    'questionnaires.dialogEditOption': 'Edit option',
    'questionnaires.colCode': 'Code',
    'questionnaires.colTitle': 'Title',
    'questionnaires.colDescription': 'Description',
    'questionnaires.colOrder': 'Order',
    'questionnaires.colStatus': 'Status',
    'questionnaires.colType': 'Type',
    'questionnaires.colLabel': 'Label',
    'questionnaires.colActions': 'Actions',
    'questionnaires.minSelections': 'Min selections',
    'questionnaires.maxSelections': 'Max selections',
    'questionnaires.required': 'Required',
    'questionnaires.status.active': 'Active',
    'questionnaires.status.inactive': 'Inactive',
    'questionnaires.answers': 'Answers',
    'questionnaires.emptyAnswers': 'No answers',
    'questionnaires.colUser': 'User',
    'questionnaires.colCompleted': 'Completed',
    'questionnaires.colAnswers': 'Answers',
    'questionnaires.completedYes': 'Yes',
    'questionnaires.completedNo': 'No',
    'questionnaires.yes': 'Yes',
    'questionnaires.no': 'No',

    'postureInstructions.title': 'Posture instructions',
    'postureInstructions.new': 'New instruction',
    'postureInstructions.refresh': 'Refresh',
    'postureInstructions.empty': 'No instructions',
    'postureInstructions.deleteConfirm': 'Delete instruction "{title}"?',
    'postureInstructions.deleteFailed': 'Failed to delete instruction',
    'postureInstructions.saveFailed': 'Failed to save instruction',
    'postureInstructions.enterType': 'Enter posture type',
    'postureInstructions.enterTitle': 'Enter title',
    'postureInstructions.enterDescription': 'Enter description',
    'postureInstructions.enterOrder': 'Enter valid order (integer >= 0)',
    'postureInstructions.dialogNew': 'New posture instruction',
    'postureInstructions.dialogEdit': 'Edit posture instruction',
    'postureInstructions.colType': 'Type',
    'postureInstructions.colTitle': 'Title',
    'postureInstructions.colOrder': 'Order',
    'postureInstructions.colStatus': 'Status',
    'postureInstructions.colImage': 'Image',
    'postureInstructions.colActions': 'Actions',
    'postureInstructions.fieldType': 'Type',
    'postureInstructions.fieldTitle': 'Title',
    'postureInstructions.fieldDescription': 'Description',
    'postureInstructions.fieldOrder': 'Order',
    'postureInstructions.fieldStatus': 'Status',
    'postureInstructions.status.active': 'Active',
    'postureInstructions.status.inactive': 'Inactive',
    'postureInstructions.status.archived': 'Archived',
    'postureInstructions.imageSection': 'Illustration',
    'postureInstructions.imageAbsent': 'None',
    'postureInstructions.selectImage': 'Select from library',
    'postureInstructions.selectImagePlaceholder': 'Choose an image',
    'postureInstructions.clearImage': 'Clear selection',
    'postureInstructions.openLibrary': 'Open media library',

    'mediaFiles.title': 'Media library',
    'mediaFiles.upload': 'Upload file',
    'mediaFiles.refresh': 'Refresh',
    'mediaFiles.empty': 'No files',
    'mediaFiles.deleteConfirm': 'Delete file "{name}"? Linked records will lose the reference.',
    'mediaFiles.deleteFailed': 'Failed to delete file',
    'mediaFiles.saveFailed': 'Failed to save file',
    'mediaFiles.uploadFailed': 'Failed to upload file',
    'mediaFiles.enterName': 'Enter file name',
    'mediaFiles.pickFile': 'Choose file',
    'mediaFiles.invalidFormat':
        'Allowed: images SVG/PNG/JPEG/WebP/GIF (max 5 MB); audio MP3/WAV/OGG/M4A (max 20 MB); video MP4/WebM/MOV (max 80 MB)',
    'mediaFiles.formatsHint':
        'Images: SVG, PNG, JPEG, WebP, GIF (max 5 MB). Audio: MP3, WAV, OGG, M4A (max 20 MB). Video: MP4, WebM, MOV (max 80 MB).',
    'mediaFiles.selectAv': 'Select audio or video',
    'mediaFiles.selectAvPlaceholder': 'Choose audio or video',
    'mediaFiles.kind.image': 'Image',
    'mediaFiles.kind.audio': 'Audio',
    'mediaFiles.kind.video': 'Video',
    'mediaFiles.kind.unknown': 'File',
    'mediaFiles.uploadDialog': 'Upload media file',
    'mediaFiles.editDialog': 'Rename media file',
    'mediaFiles.colPreview': 'Preview',
    'mediaFiles.colName': 'Name',
    'mediaFiles.colType': 'Type',
    'mediaFiles.colFilename': 'File',
    'mediaFiles.colMime': 'MIME type',
    'mediaFiles.colCreated': 'Created',
    'mediaFiles.colActions': 'Actions',
    'mediaFiles.fieldName': 'Name',

    'testScripts.title': 'Python scripts',
    'testScripts.upload': 'Upload script',
    'testScripts.refresh': 'Refresh',
    'testScripts.empty': 'No scripts',
    'testScripts.sectionPdf': 'PDF generation',
    'testScripts.sectionIndicators': 'Indicators',
    'testScripts.deleteConfirm': 'Delete script "{name}"?',
    'testScripts.deleteFailed': 'Failed to delete script. It may be used by configurations.',
    'testScripts.saveFailed': 'Failed to save script',
    'testScripts.uploadFailed': 'Failed to upload script',
    'testScripts.download': 'Download file',
    'testScripts.downloadFailed': 'Failed to download script file',
    'testScripts.replaceFile': 'Replace file',
    'testScripts.replaceDialog': 'Replace Python script file',
    'testScripts.currentFile': 'Current file',
    'testScripts.chooseReplacement': 'Choose a new .py file',
    'testScripts.replaceFailed': 'Failed to replace script file',
    'testScripts.replaceSuccess': 'Script file replaced successfully',
    'testScripts.enterName': 'Enter script name',
    'testScripts.pickFile': 'Choose .py file',
    'testScripts.invalidFormat': 'Only .py files up to 2 MB are allowed',
    'testScripts.uploadDialog': 'Upload Python script',
    'testScripts.editDialog': 'Rename script',
    'testScripts.colName': 'Name',
    'testScripts.colPurpose': 'Section',
    'testScripts.colFilename': 'File',
    'testScripts.colCreated': 'Created',
    'testScripts.colActions': 'Actions',
    'testScripts.fieldName': 'Name',
    'testScripts.fieldPurpose': 'Section',

    'testMetrics.title': 'Test metrics',
    'testMetrics.new': 'New metric',
    'testMetrics.refresh': 'Refresh',
    'testMetrics.empty': 'No metrics',
    'testMetrics.deleteConfirm': 'Delete metric "{type}"?',
    'testMetrics.deleteFailed': 'Failed to delete metric',
    'testMetrics.saveFailed': 'Failed to save metric',
    'testMetrics.enterType': 'Enter metric type',
    'testMetrics.enterTitle': 'Enter title',
    'testMetrics.enterValidationKey': 'Enter validation key',
    'testMetrics.invalidHex': 'Invalid hex color (#RRGGBB)',
    'testMetrics.scaleMinMax': 'Scale "{name}": min must be less than max',
    'testMetrics.levelMinMax': 'Level "{label}": min must be <= max',
    'testMetrics.dialogNew': 'New test metric',
    'testMetrics.dialogEdit': 'Edit test metric',
    'testMetrics.colType': 'Type',
    'testMetrics.colTitle': 'Title',
    'testMetrics.colValueType': 'Value type',
    'testMetrics.colEnabled': 'Enabled',
    'testMetrics.colScales': 'Scales',
    'testMetrics.colDisclaimers': 'Disclaimers',
    'testMetrics.colActions': 'Actions',
    'testMetrics.enabled': 'Yes',
    'testMetrics.disabled': 'No',
    'testMetrics.sectionMain': 'Metric',
    'testMetrics.sectionScales': 'Scales',
    'testMetrics.sectionLevels': 'Levels',
    'testMetrics.fieldType': 'Type',
    'testMetrics.fieldTitle': 'Title',
    'testMetrics.fieldShortTitle': 'Short title',
    'testMetrics.fieldDescription': 'Description',
    'testMetrics.fieldBenefits': 'Benefits',
    'testMetrics.fieldUnit': 'Unit',
    'testMetrics.fieldValueType': 'Value type',
    'testMetrics.fieldIcon': 'Icon',
    'testMetrics.fieldIconColor': 'Icon color',
    'testMetrics.fieldValidationKey': 'Validation key',
    'testMetrics.fieldTrendStrategy': 'Trend strategy',
    'testMetrics.fieldFormatterKey': 'Formatter key',
    'testMetrics.fieldDecimals': 'Decimals',
    'testMetrics.fieldNullDisplay': 'Null display',
    'testMetrics.fieldTags': 'Tags (comma-separated)',
    'testMetrics.disclaimerIds': 'Disclaimers',
    'testMetrics.fieldEnabled': 'Enabled',
    'testMetrics.fieldWorkout': 'Workout metric',
    'testMetrics.fieldInvertedProgress': 'Inverted progress',
    'testMetrics.fieldClamp': 'Clamp to scale',
    'testMetrics.addScale': 'Add scale',
    'testMetrics.removeScale': 'Remove scale',
    'testMetrics.scaleUntitled': 'Scale {n}',
    'testMetrics.levelsCount': 'levels',
    'testMetrics.scaleName': 'Scale name',
    'testMetrics.scaleDescription': 'Scale description',
    'testMetrics.scaleUnit': 'Unit',
    'testMetrics.scaleMin': 'Min',
    'testMetrics.scaleMax': 'Max',
    'testMetrics.scaleIndex': 'Index',
    'testMetrics.scaleInverted': 'Inverted',
    'testMetrics.addLevel': 'Add level',
    'testMetrics.levelLabel': 'Label',
    'testMetrics.levelPriority': 'Priority',
    'testMetrics.levelColor': 'Color',

    'sensecap.title': 'SenseCAP — rhythmogram / HRV',
    'sensecap.devices': 'Devices (devEui)',
    'sensecap.selectDevice': 'Select a device on the left',
    'sensecap.chartFor': 'Device: {devEui}',
    'sensecap.limit': 'Uplinks (limit)',
    'sensecap.from': 'From',
    'sensecap.to': 'To',
    'sensecap.noDevices': 'No device data yet',
    'sensecap.loadDevicesError': 'Failed to load devices',
    'sensecap.loadSamplesError': 'Failed to load samples',
    'sensecap.deviceMeta': 'Packets: {count}, last: {lastSeen}, RSSI: {rssi}',
    'sensecap.samplesMeta': 'Uplinks: {uplinks}, sessions: {sessions}, points: {points}',
    'sensecap.sessionMeta': 'Session: {uplinks} uplink(s), {start} — {end}, points: {points}',
    'sensecap.sessionPage': 'Session {current} of {total}',
    'sensecap.prevSession': 'Previous session',
    'sensecap.nextSession': 'Next session',
    'sensecap.rhythmogram': 'Ritmogram RR',
    'sensecap.histogram': 'Histogram of RR intervals',
    'sensecap.scatterogram': 'Scatterogram of RR intervals',
    'sensecap.amplitude': 'R-peak amplitude',
    'sensecap.hrvEmpty': 'Not enough RR intervals for HRV (need at least 2 after filtering).',
    'sensecap.hr': 'HR',
    'sensecap.sdnn': 'SDNN',
    'sensecap.rmssd': 'RMSSD',
    'sensecap.pnn20': 'pNN20',
    'sensecap.pnn50': 'pNN50',
    'sensecap.unitBpm': 'bpm',
    'sensecap.unitMs': 'ms',
    'sensecap.unitPct': '%',
    'sensecap.normalRange': 'normal: {min}–{max}',
    'sensecap.axisTimeMs': 'Time (ms)',
    'sensecap.axisRrMs': 'RR (ms)',
    'sensecap.axisNextRrMs': 'Next RR (ms)',
    'sensecap.axisCount': 'Count',

    'disclaimers.title': 'Disclaimers',
    'disclaimers.new': 'New disclaimer',
    'disclaimers.refresh': 'Refresh',
    'disclaimers.empty': 'No disclaimers',
    'disclaimers.dialogNew': 'New disclaimer',
    'disclaimers.dialogEdit': 'Edit disclaimer',
    'disclaimers.deleteConfirm': 'Delete disclaimer "{code}"?',
    'disclaimers.deleteFailed': 'Failed to delete disclaimer',
    'disclaimers.saveFailed': 'Failed to save disclaimer',
    'disclaimers.enterCode': 'Enter code',
    'disclaimers.duplicateCode': 'Code "{code}" already exists',
    'disclaimers.enterBody': 'Enter body',
    'disclaimers.enterAcknowledgementLabel': 'Enter acknowledgement label',
    'disclaimers.invalidData': 'Invalid data JSON',
    'disclaimers.colCode': 'Code',
    'disclaimers.colStatus': 'Status',
    'disclaimers.colPlacement': 'Placement',
    'disclaimers.colSeverity': 'Severity',
    'disclaimers.colBody': 'Body',
    'disclaimers.colTargets': 'Targets',
    'disclaimers.colActions': 'Actions',
    'disclaimers.fieldCode': 'Code',
    'disclaimers.fieldStatus': 'Status',
    'disclaimers.fieldPlacement': 'Placement',
    'disclaimers.fieldSeverity': 'Severity',
    'disclaimers.fieldRequireAcknowledgement': 'Require acknowledgement',
    'disclaimers.fieldAcknowledgementLabel': 'Acknowledgement label',
    'disclaimers.fieldTitle': 'Title',
    'disclaimers.fieldBody': 'Body',
    'disclaimers.fieldData': 'Data (JSON)',
    'disclaimers.fieldConfigurations': 'Test configurations',
    'disclaimers.fieldMetrics': 'Test metrics',
    'disclaimers.status.active': 'Active',
    'disclaimers.status.inactive': 'Inactive',
    'disclaimers.placement.dialog': 'Dialog',
    'disclaimers.placement.inline': 'Inline',
    'disclaimers.placement.card': 'Card',
    'disclaimers.severity.info': 'Info',
    'disclaimers.severity.warning': 'Warning',

    'legalDocuments.title': 'Legal documents',
    'legalDocuments.new': 'New document',
    'legalDocuments.newVersion': 'New version',
    'legalDocuments.seed': 'Create catalog drafts',
    'legalDocuments.seedConfirm': 'Create missing draft documents for the standard catalog?',
    'legalDocuments.seedFailed': 'Failed to create catalog drafts',
    'legalDocuments.refresh': 'Refresh',
    'legalDocuments.empty': 'No documents',
    'legalDocuments.dialogNew': 'New legal document',
    'legalDocuments.dialogEdit': 'Edit legal document',
    'legalDocuments.dialogVersion': 'New document version',
    'legalDocuments.publish': 'Publish',
    'legalDocuments.publishConfirm': 'Publish {code} version {version}? The current active version will be superseded.',
    'legalDocuments.publishFailed': 'Failed to publish document',
    'legalDocuments.supersede': 'Supersede',
    'legalDocuments.supersedeConfirm': 'Mark {code} version {version} as superseded?',
    'legalDocuments.supersedeFailed': 'Failed to supersede document',
    'legalDocuments.deleteConfirm': 'Delete draft {code} version {version}?',
    'legalDocuments.deleteFailed': 'Failed to delete document',
    'legalDocuments.saveFailed': 'Failed to save document',
    'legalDocuments.enterCode': 'Enter code',
    'legalDocuments.enterVersion': 'Enter version',
    'legalDocuments.invalidData': 'Invalid data JSON',
    'legalDocuments.colCode': 'Code',
    'legalDocuments.colVersion': 'Version',
    'legalDocuments.colStatus': 'Status',
    'legalDocuments.colMode': 'Acceptance',
    'legalDocuments.colTitle': 'Title',
    'legalDocuments.colEffective': 'Effective',
    'legalDocuments.colActions': 'Actions',
    'legalDocuments.fieldCode': 'Code',
    'legalDocuments.fieldVersion': 'Version',
    'legalDocuments.fieldType': 'Type',
    'legalDocuments.fieldMode': 'Acceptance mode',
    'legalDocuments.fieldReacceptance': 'Require reacceptance',
    'legalDocuments.fieldEffective': 'Effective at',
    'legalDocuments.fieldTitle': 'Title',
    'legalDocuments.fieldContentUrl': 'Content URL',
    'legalDocuments.fieldHtml': 'Upload HTML',
    'legalDocuments.fieldData': 'Data (JSON)',
    'legalDocuments.localeEn': 'English',
    'legalDocuments.localeRu': 'Russian',
    'legalDocuments.status.draft': 'Draft',
    'legalDocuments.status.active': 'Active',
    'legalDocuments.status.superseded': 'Superseded',
    'legalDocuments.mode.required': 'Required',
    'legalDocuments.mode.acknowledge': 'Acknowledge',
    'legalDocuments.mode.optional': 'Optional',
    'legalDocuments.mode.view_only': 'View only',
    'legalDocuments.type.terms': 'Terms',
    'legalDocuments.type.privacy': 'Privacy',
    'legalDocuments.type.esign': 'E-sign',
    'legalDocuments.type.health_data': 'Health data',
    'legalDocuments.type.team_sharing': 'Team sharing',
    'legalDocuments.type.guardian': 'Guardian',
    'legalDocuments.type.wellness': 'Wellness',
};
